import { COST_SUMMARY_FAIL, COST_SUMMARY_REQUEST, COST_SUMMARY_RESET, COST_SUMMARY_SUCCESS } from "../../constants/ConstSummaryConstants";


export const costSummaryReducer = (state = { costSummary: [] }, action) => {
  switch (action.type) {
    case COST_SUMMARY_REQUEST:
      return { loading: true };
    case COST_SUMMARY_SUCCESS:
      return { loading: false, costSummary: action.payload };
    case COST_SUMMARY_FAIL:
      return { loading: false, error: action.payload };
    case COST_SUMMARY_RESET:
      return { costSummary: [] };
    default:
      return state;
  }
};

const initialState = { loading: false, error: null, data: { costSummary: [], inventoryUtilization: [] } };

export const costAndInventoryUtilizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ANAL_COST_INVENTORY_REQUEST':
      return { ...state, loading: true };
    case 'ANAL_COST_INVENTORY_SUCCESS':
      return { ...state, loading: false, data: action.payload };
    case 'ANAL_COST_INVENTORY_FAIL':
      return { ...state, loading: false, error: action.payload };
    case 'ANAL_COST_INVENTORY_RESET':
      return initialState;
    default:
      return state;
  }
};